module.exports = {
	"url": "https://github.com/plasma-umass/doppio_jcl/releases/download/v3.2/java_home.tar.gz",
	"classpath": [
		"lib/rt.jar",
		"lib/charsets.jar",
		"lib/doppio.jar",
		"lib/dt.jar",
		"lib/jce.jar",
		"lib/jconsole.jar",
		"lib/jsse.jar",
		"lib/management-agent.jar",
		"lib/resources.jar",
		"lib/sa-jdi.jar",
		"lib/tools.jar"
	]
};


//////////////////
// WEBPACK FOOTER
// ./vendor/java_home/jdk.json
// module id = 33
// module chunks = 0